import type { ValuesOf } from '@do/utils/types';

export const ThemeModes = {
  Dark: 'dark',
  Light: 'light',
  Default: null,
} as const;

export type ThemeModes = ValuesOf<typeof ThemeModes>;
